import { ValueObject } from '@nx-smartmonkey/shared/domain';
import { DriversSubscriptionCredentials } from './DriversSubscriptionCredentials';

export type DriversPermissions =
  | `can_view_routes`
  | `can_delete_report`
  | `can_use_pin`
  | `can_create_survey`
  | `can_track_position`
  | `can_update_route_status`
  | `can_view_vehicle_avatar`
  | `can_update_route_order`
  | `can_manage_stops`
  | `can_update_stop_tasks`
  | `can_view_finished_plans`
  | `can_view_planning_plans`
  | `can_view_planning_times`
  | `can_manage_routes`;

interface DriverCredentialsProps {
  id: string;
  meta: any;
  project_id: string;
  organization_id: string;
  permissions: DriversPermissions[];
  subscription: DriversSubscriptionCredentials;
}

export class DriverCredentials extends ValueObject<DriverCredentialsProps> {
  private constructor(props: DriverCredentialsProps) {
    super(props);
  }

  static create(props: DriverCredentialsProps): DriverCredentials {
    return new DriverCredentials(props);
  }

  test(...permissions: DriversPermissions[]) {
    return permissions.every((permission) => this.props.permissions.includes(permission));
  }

  get id(): string {
    return this.props.id;
  }

  get meta(): any {
    return this.props.meta;
  }

  get project_id(): string {
    return this.props.project_id;
  }

  get organization_id(): string {
    return this.props.organization_id;
  }

  get permissions(): DriversPermissions[] {
    return this.props.permissions;
  }

  get subscription(): DriversSubscriptionCredentials {
    return this.props.subscription;
  }
}
